// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"566":"45692589","973":"d0664f2c"}[chunkId] + ".chunk.css";
};